<template>
  <div class="zt-table" ref="ztTable">
    <div class="zt-table-wrapper">
      <div class="w-full">
        <div class="zt-table-header bg-zt-white" ref="ztTableHeader">
          <div v-if="searcher"
            class="zt-table-header--search flex w-full px-6 h-20 items-center justify-between border-b">
            <div class="w-1/3 md:w-1/3 pointer-events-none relative">
              <slot name="tableTitle">
                <zt-input label="Busqueda no disponible" outlined prepend-icon="search-outline" :disabled="true" />
              </slot>
            </div>
            <div class="text-zt-base">Total: {{ items.length }}</div>
          </div>
          <table class="w-full table m-0 border-b" :class="isVisibleHeader">
            <thead>
              <tr class="w-full text-center h-16 border-none">
                <th class="zt-table-header--col h-16 p-4 text-zt-dark-400 border-none">
                  <zt-check-box v-model="allRowSelected" fill :indeterminate="indeterminateSelection"/>
                </th>
                <th class="zt-table-header--col h-16 p-4 text-zt-dark-400 border-none"
                  :class="{ 'cursor-pointer ': col.sortable }" v-for="(col, index) in columns" :key="index"
                  :style="{ width: `${col.width}px` }" ref="headerColumn" v-show="showColumns(col)"
                  @click="sortBy(col)">
                  <div class="flex items-center">
                    <span>{{ col.text }}</span>
                    <div v-if="col.sortable" class="ml-1">
                      <zt-icon name="sorting-arrows" />
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="zt-table-body overflow-x-hidden" :class="{ 'overflow-y-auto': activeScroll }"
          :style="{ height: internalTableHeight }">
          <div class="h-inherit">
            <zt-table-row v-for="(item, index) in items" :key="index" :row-data="item" :id-selectable="String(index)"
              :attr-columns="genAttrsColumn" :visible-columns="visibleColumns"
              :class="{ 'is-active': index === activeRow }" :max-text-length-truncate="maxTruncate"
              @select="rowSelected($event, index)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ztTable',
  inheritAttrs: false,
}
</script>

<style src="../../../../styles/components/ztTable.css" lang="css" scoped></style>
